import * as React from 'react';
import type { FC } from 'react';
import { useLocales } from './locales';
import iconReset from './images/icon_reset.svg';

// Takes the banner toggle's place during a search.
const ResetSearch: FC<{ onReset: () => void }> = ({ onReset }) => {
  const l = useLocales();

  return (
    <button type="button" className="filters_end-button filters_end-button_reset" onClick={onReset}>
      <img src={iconReset} alt="" />
      <span className="filters_end-button-label">{l('reset_search')}</span>
    </button>
  );
};

export default ResetSearch;
